export default "__VITE_ASSET__CK$e5Msk__"